import {
  defaultHolidayOvertimeRatePercentage,
  defaultHolidayRatePercentage,
} from '../../company-management/action-team/reducers/action-team';
import { CreateRoleForm } from '../models/create-external-role-form';
import { FinancialUtils } from './financial';

export class ATeamCalculations {
  static calcExternalRoleModalValues(
    form: CreateRoleForm,
    onlyOvertime: boolean,
  ): CreateRoleForm {
    const oldValue = { ...form };
    const newValue = { ...form };
    newValue.costPricePerHour = onlyOvertime
      ? oldValue.costPricePerHour
      : FinancialUtils.fromPercents(
          oldValue.defaultCostPricePerHour,
          oldValue.normalRatePercentage,
        );
    newValue.sellPricePerHour = onlyOvertime
      ? oldValue.defaultSellPricePerHour
      : FinancialUtils.fromPercents(
          oldValue.defaultSellPricePerHour,
          oldValue.normalRatePercentage,
        );
    newValue.overtimeCostPricePerHour = FinancialUtils.fromPercents(
      newValue.defaultCostPricePerHour,
      oldValue.overtimeRatePercentage,
    );
    newValue.overtimeSellPricePerHour = FinancialUtils.fromPercents(
      newValue.defaultSellPricePerHour,
      oldValue.overtimeRatePercentage,
    );

    newValue.holidayHourPriceUnitPrice = FinancialUtils.fromPercents(
      newValue.defaultCostPricePerHour,
      oldValue.holidayHourPricePercentage || defaultHolidayRatePercentage,
    );
    newValue.holidayOvertimePriceUnitPrice = FinancialUtils.fromPercents(
      newValue.defaultCostPricePerHour,
      oldValue.holidayOvertimePricePercentage || defaultHolidayOvertimeRatePercentage,
    );

    newValue.holidayHourPriceBillablePrice = FinancialUtils.fromPercents(
      newValue.defaultSellPricePerHour,
      oldValue.holidayHourPricePercentage || defaultHolidayRatePercentage,
    );
    newValue.holidayOvertimePriceBillablePrice = FinancialUtils.fromPercents(
      newValue.defaultSellPricePerHour,
      oldValue.holidayOvertimePricePercentage || defaultHolidayOvertimeRatePercentage,
    );

    return newValue;
  }
}
